const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * 60;
const SECONDS_PER_DAY = 24 * 60 * 60;
// moment's duration thresholds: a month is 365.25 / 12 days, a year is 365.25 days.
const SECONDS_PER_MONTH = SECONDS_PER_DAY * (365.25 / 12);
const SECONDS_PER_YEAR = SECONDS_PER_DAY * 365.25;

/**
 * Humanize a non-negative duration in seconds the way Ember's `duration` helper
 * did (moment `.from(x, true)`, `en` locale, no suffix): "a few seconds", "a
 * minute", "%d minutes", "an hour", "%d hours", "a day", … The thresholds
 * mirror moment's defaults so the wording matches character-for-character.
 */
export function humanizeDurationSeconds(totalSeconds: number): string {
  const seconds = Math.round(totalSeconds);
  const minutes = Math.round(totalSeconds / SECONDS_PER_MINUTE);
  const hours = Math.round(totalSeconds / SECONDS_PER_HOUR);
  const days = Math.round(totalSeconds / SECONDS_PER_DAY);
  const months = Math.round(totalSeconds / SECONDS_PER_MONTH);
  const years = Math.round(totalSeconds / SECONDS_PER_YEAR);

  if (seconds <= 44) return 'a few seconds';
  if (minutes <= 1) return 'a minute';
  if (minutes < 45) return `${minutes} minutes`;
  if (hours <= 1) return 'an hour';
  if (hours < 22) return `${hours} hours`;
  if (days <= 1) return 'a day';
  if (days < 26) return `${days} days`;
  if (months <= 1) return 'a month';
  if (months < 11) return `${months} months`;
  if (years <= 1) return 'a year';
  return `${years} years`;
}

/**
 * The expanded row's "<duration> later" label — the gap between a lifecycle
 * event and the delivery's creation (Ember `DurationTimestamp` with `@tail='
 * later'`). Equal timestamps read "less than a second" (Ember's `duration`
 * fallback for a zero gap); everything else the humanized gap.
 */
export function formatDurationLater(referenceTs: number, ts: number): string {
  const deltaSeconds = ts - referenceTs;
  const magnitude = deltaSeconds <= 0 ? 'less than a second' : humanizeDurationSeconds(deltaSeconds);
  return `${magnitude} later`;
}
